import { useContext, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom"
import L from 'leaflet'
import "leaflet.heat";
import { getCoordenadasActas } from "./handlers";
import { UserContext } from "../../context";

const MapaDeCalor = () => {
  const { actions: ua } = useContext(UserContext)
  const navigate = useNavigate();

  useEffect(() => {
    const buildMap = async () => {
      const data = await getCoordenadasActas();
      if (!data) {
        return;
      }

      let container = L.DomUtil.get('map');
      if (container != null) {
        container._leaflet_id = null;
      }

      let map = L.map("map", { attributionControl: false }).setView([-38.957134, -68.052363], 15);
      L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
        minZoom: 11,
        maxZoom: 20,
      }).addTo(map);
      L.heatLayer(data, {
        radius: 15, maxZoom: 5,
      }).addTo(map);

      // return () => map.remove();
    }

    if (ua.hasRole('sudo')) {
      buildMap()
    } else {
      navigate('/')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <div className="d-flex gap-4 align-items-center mb-4">
        <h3 className="mb-0">Mapa de Calor</h3>
        <Link to='/' className='my-auto  ms-auto me-1 btn btn-primary' style={{ maxHeight: '38px' }}>
          <span>Volver</span>
        </Link>
      </div>
      <div id="map" style={{ height: "100vh" }}></div>
    </div>
  )
}

export default MapaDeCalor